import * as React from 'react';

export default {
  phoneNumber: () => (
    <>
      <a href="tel:+17196334100">Colorado Springs: (719) 633-4100</a>
      <br />
      <a href="tel:+13034002988">Aurora: (303) 400-2988</a>
    </>
  ),
};
